const bookTypesReducer = (state = [{code: "ALL", description: "All"}], action) => {
  switch (action.type) {
    case 'LANDLINK_BOOK_TYPES':
      return action.results;
    default:
      break;
  }
  return state;
}

export default bookTypesReducer;